export default __webpack_public_path__ + "static/media/js-info.85636ad6.png";